import React from 'react';
import {backEndUri} from '../../config';
import NeedAdmin from "../NeedAdmin";
import {FormattedMessage} from "react-intl";

export default function PhotoboothCellPhotosZipButton({cell}){
    return(
        <NeedAdmin trueAdmin>
            <a
                href={`${backEndUri}/photo/${cell.id}/photos-zip`}
                download
                style={{
                display: 'inline-block',
                padding: '0.5em 1em',
                textAlign: 'center',
                textDecoration: 'none',
                backgroundColor: 'white',
                color: 'black',
                border: '1px solid #ccc',
                borderRadius: '4px',
                cursor: 'pointer'
                }}
                className="tsk-upper"
            >
                <FormattedMessage id="projects.photos.zip.button" />
            </a>
        </NeedAdmin>
    );
}
